import { Link } from 'react-router-dom';
import { Icon } from '../icon';
import { StyledPageBack } from './style';

export const PageBack = ({ to, text }) => {
  return (
    <StyledPageBack>
      <Link to={to}>
        <Icon icon="long-arrow-alt-left" />

        {text}
      </Link>
    </StyledPageBack>
  )
}

export default PageBack;
